export const STATE_PROP_NAME = 'healthVolumeMatrix'
